import React, { useState } from 'react';
import { Alert, Box, Card, CardContent, CircularProgress, Snackbar } from '@mui/material';
import { ResponsiveAdminLayout } from '../components/ResponsiveAdminLayout';
import { AccessLinkPanel } from '../components/AccessLinkPanel';
import { useAuth, useCompany } from '../hooks/useAuth';
import { useIsDesktop } from '../hooks/useMediaQuery';
import { AppColors } from '../theme/colors';

/**
 * 投稿用のQRコード・URLだけを確認する画面（坂本様ご指摘④）。
 *
 * これまでは会社管理の「システム設定」から開くダイアログにしかなく、
 * 何度も画面を移る手間があり、見つけにくかった。メニューからすぐ開けるよう別の画面にした。
 * 表示・保存・コピーの中身は会社管理のダイアログと同じ（AccessLinkPanel）。
 */
export const AccessLinkPage: React.FC = () => {
  const isDesktop = useIsDesktop();
  const { user } = useAuth();
  const { company } = useCompany(user?.uid || null);
  const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: 'success' | 'error' }>({
    open: false,
    message: '',
    severity: 'success',
  });

  return (
    <ResponsiveAdminLayout pageTitle="投稿用のQRコード・URL">
      {/* 基準の余白の状態: PCは最大幅1000px・中央寄せ */}
      <Box sx={{ maxWidth: isDesktop ? '1000px' : '100%', mx: isDesktop ? 'auto' : 0, width: '100%', p: 2 }}>
        <Card sx={{ borderRadius: 3, border: `1px solid ${AppColors.border}`, maxWidth: 640, mx: 'auto' }}>
          <CardContent sx={{ p: isDesktop ? 3 : 2 }}>
            {company ? (
              <AccessLinkPanel
                companyName={company.companyName ?? ''}
                corporateCode={company.corporateCode ?? ''}
                canRotate={user?.userType === 'superadmin'}
                onNotify={(message, severity) => setSnackbar({ open: true, message, severity })}
              />
            ) : (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <CircularProgress size={28} />
              </Box>
            )}
          </CardContent>
        </Card>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </ResponsiveAdminLayout>
  );
};
